import "bootstrap/dist/css/bootstrap.min.css";
import classNames from "classnames";
import { Badge } from "components/design/badge";
import ConditionalToolTip from "components/design/conditionalToolTip";
import ToolTip from "components/design/toolTip";
import { Button } from "components/DesignSystem/Button/Button";
import {
  Combobox,
  OptionData,
} from "components/DesignSystem/Combobox/Combobox";
import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import Modal from "components/DesignSystem/Modal/Modal";
import { Link } from "components/DesignSystem/Link/Link";
import Table from "components/DesignSystem/Table/V2/Table";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "components/DesignSystem/ToggleGroup/ToggleGroup";
import { Chat } from "components/icons/LeftNav/Chat";
import { ETDUpdateReason } from "components/TaskSlider/ETDUpdateReason/ETDUpdateReason";
import { TaskSlider } from "components/TaskSlider/TaskSlider";
import {
  DropdownIndicator,
  TransactionComboboxClearIndicator,
  TransactionComboboxControl,
} from "components/Transaction/TransactionColumn";
import { NO_ASSGINEE_KEY, NO_ASSIGNEE } from "constants/agent";
import { YYYY_MM_DD } from "constants/date";
import { NO_TAG, NO_TAG_KEY } from "constants/tagColors";
import {
  ALL,
  ARCHIVED,
  BOOKS_COMPLETED,
  BOOKS_IN_PROGRESS,
  BOOKS_NOT_STARTED,
  COMPLETED,
  MISSING_BUSINESS_FINANCIALS_FORM_7004_FLAG,
  MISSING_INFORMATION_FORM_7004_FLAG,
  NON_PROFITABLE,
  ONGOING,
  PROFITABLE,
  TASK_SLIDER_TABS,
} from "constants/task";
import dayjs from "dayjs";
import {
  CRM_SUBSCRIPTION_BADGE_MAP,
  CRM_SUBSCRIPTION_TYPE,
} from "dictionaries";
import { Field, FieldProps, Form, Formik } from "formik";
import { useFilters } from "hooks/useFilter";
import { useModal } from "hooks/useModal";
import { usePageTitle } from "hooks/usePageTitle";
import { useQuery, useUpdateQuery } from "hooks/useQuery";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import { useUnreadFromChannels } from "hooks/useUnreadFromChannels";
import authContext from "jwt_context&axios/authContext";
import {
  HTMLAttributes,
  memo,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useParams,
  useRouteMatch,
} from "react-router-dom";
import { MultiValue, SingleValue } from "react-select";
import {
  CellContext,
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  RowSelectionState,
  useReactTable,
} from "react-table-8.10.7";
import "static/styles/components/tasksPage.css";
import "static/styles/components/userPage.css";
import { useGetTaskTemplatesQuery } from "store/apis/getTemplates";
import { useGetAllInkleCPATeamsQuery } from "store/apis/internalTeamSetting";
import {
  useGetAllServiceProviderTaskQuery,
  useGetServiceTeamQuery,
  useUpdateTaskAssigneeAdminMutation,
  useUpdateTaskAssigneeProviderMutation,
} from "store/apis/serviceTeam";
import {
  useGetAllTaskStatesQuery,
  useGetTaskTagQuery,
} from "store/apis/taskTags";
import { useChatContext } from "stream-chat-react";
import { Tag } from "types/Models/FCA";
import { Task, TaskSliderTabs } from "types/Models/task";
import { BackendError } from "types/utils/error";
import { formatDate } from "utils/formatDate";
import { stopPropagation } from "utils/stopPropagation";
import {
  defaultSortOption,
  sortOptions,
} from "../../../constants/foreignCATask";
import { FORM_FILING, SUBMITTED } from "../../../constants/taskStates";
import { NOT_STARTED, NOT_STARTED_KEY } from "../../../constants/taskStatus";
import "../../../static/styles/components/addTeamMember.css";
import "../../../static/styles/components/consultantDashBoard.css";
import { openLink } from "../../../utils/openLink";
import Loader from "../../DesignSystem/Loader/loader";
import NoDataAvailable from "../../design/noDataAvailable";
import TagCreation from "../../tagCreation/tagCreation";

import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";
import { Tag as TagComp, TagColorType } from "components/DesignSystem/Tag/Tag";
import {
  ClientStageTagTypes,
  TaskStateTagTypes,
} from "components/Task/EntityTaskList/TaskStates";
import {
  FILTER_BOOKS_PENDING,
  STAGE_KEY_BOOKS_PENDING,
  STAGE_KEY_DRAFT_SHARED,
  STAGE_KEY_IN_QUEUE,
  STAGE_KEY_MI_RAISED_WITH_BOOKS,
  STAGE_KEY_MISSING_INFORMATION,
  STAGE_KEY_PREPARER_ASSIGNED,
  STAGE_KEY_PREP_IN_PROGRESS,
  STAGE_KEY_REVIEW_IN_FINAL,
  STAGE_KEY_REVIEW_IN_PROGRESS,
  STATUS_DRAFT_SHARED,
  STATUS_INFORMATION_REQUIRED,
  STATUS_INTERNAL_REVIEW,
  STATUS_IN_FINAL_REVIEW,
  STATUS_MI_RAISED_WITH_BOOKS,
  STATUS_ON_HOLD,
  TRACKER_STATUS_NAME_IN_FINAL_REVIEW,
  TRACKER_STATUS_NAME_INTERNAL_REVIEW,
  TRACKER_STATUS_NAME_MI_RAISED_WITH_BOOKS,
} from "components/TaskTracker/Task1120FilterOptions";
import { NotePencil } from "components/icons/NotePencil";
import { AmendmentTag } from "components/Task/AmendmentTag/AmendmentTag";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { UnifyNotes } from "components/Notes/UnifyNotes";
import { AddTaskDeadline } from "components/Task/AddTaskDeadline";
import { UpdateTaskDeadline } from "components/Task/UpdateTaskDeadline";
import { PreparerChangeConfirm } from "components/TaskSlider/PreparerChangeConfirm";
import { ServiceTeamChangeModal } from "components/TaskSlider/ServiceTeamChangeModal";
import { SALES_TAX } from "constants/apps";
import { NOTE_TYPE } from "constants/unifyNotes";
import {
  useLazyExportCSVQuery,
  useSetOnHoldMutation,
  useUpdateStateMutation,
} from "store/apis/task";
import { TaskStateChangeModal } from "components/Task/TaskStateChangeModal";
import { UpdateTaskPrice } from "components/fileTax/updateTaskPrice";
import { BooksTaskStatusCombobox } from "./BooksTaskStatusCombobox";
import { BooksTaskStatusTag } from "./BooksTaskStatusTag";
import { useBooksTaskStatus } from "./useBooksTaskStatus";
import {
  TASK_TYPE,
  TaskTrackerType,
  useAssignTaskMutation,
} from "store/apis/taskTrackerSalesTax";
import { EntityTask } from "types/Models/bookkeepingTracker";
import { AD_HOC, STATE_FILING } from "types/Models/services";
import { Task1120Tracker } from "types/Models/TaskTracker";
import DashboardContainer from "components/dashboard/DashboardContainer";
import TaskTabBar from "../taskTabBar";
import { AllFilingBulkActionFloat } from "./AllFilingBulkActionFloat";
import { FilingTags } from "./FilingTags";
import { ForeignCATaskFilter } from "./ForeignCATaskFilter";
import { validate } from "uuid";
import { useGetAssignAgentsQuery } from "store/apis/agents";
import { AvatarCell } from "./AvatarCell";
import { TaskPickupDate } from "components/TaskTracker/Task1120Columns/TaskPickupDate";
import { ArrowRight } from "components/icons/ArrowRight";

export type FilterType = {
  START_DATE: string;
  END_DATE: string;
  SELECT_PERIOD: string;
  DEADLINE_START: string;
  DEADLINE_END: string;
  DEADLINE_SELECT_PERIOD: string;
  FORMATION_TYPE: string[];
  STATE_REGISTRATIONS: string[];
  FILING_INFO: string[];
};

export const TaskNotes = ({
  taskId,
  entityId,
  groupId,
  currentNoteLabel,
  allNotesCount,
}: {
  taskId: string;
  entityId: string;
  groupId: string;
  currentNoteLabel: string;
  allNotesCount: number;
}) => {
  const notesModal = useModal();
  const { alertToast, successToast } = useToast();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Button
        customType="ghost"
        onClick={(e) => {
          e.stopPropagation();
          notesModal.open();
        }}
      >
        <div className="t-flex t-gap-1 t-items-center">
          <NotePencil />
          {allNotesCount > 0 && (
            <span className="t-text-subtext t-text-text-60">
              {allNotesCount}
            </span>
          )}
        </div>
      </Button>
      {notesModal.isOpen && (
        <UnifyNotes
          isOpen={notesModal.isOpen}
          close={notesModal.close}
          groupId={groupId ?? ""}
          currentNoteLabel={currentNoteLabel}
          currentNoteType={NOTE_TYPE.TASK}
          currentNoteTypeId={taskId}
          entityId={entityId}
        />
      )}
    </div>
  );
};

export const EstimdatedTimeColumn = ({
  taskData,
  isCustomTrigger = false,
}: {
  taskData: Task | Task1120Tracker;
  isCustomTrigger?: boolean;
}) => {
  const {
    uuid: taskId,
    estimated_time_of_delivery = {},
    assigned_team,
  } = taskData;
  const color = estimated_time_of_delivery?.color;
  const date = estimated_time_of_delivery?.date;
  const etdUpdateReasonModal = useModal();

  return (
    <Formik
      onSubmit={() => {}}
      initialValues={{ estimated_delivery_time: date }}
    >
      {({ values, setFieldValue }) => (
        <Form
          data-testid="estimatedDeliveryTime"
          className="t-w-full t-m-0"
          onClick={(e) => e.stopPropagation()}
        >
          <Field name="estimated_delivery_time">
            {({ field }: FieldProps) => {
              return (
                <DateInput
                  // disabled={!Boolean(assigned_team)}
                  {...field}
                  portalId={"estimated_delivery_time_portal_" + taskId}
                  onDateChange={(date) => {
                    setFieldValue("estimated_delivery_time", date);
                    etdUpdateReasonModal.open();
                  }}
                />
              );
            }}
          </Field>
          {taskId && etdUpdateReasonModal.isOpen && (
            <ETDUpdateReason
              isOpen={etdUpdateReasonModal.isOpen}
              close={etdUpdateReasonModal.close}
              taskId={taskId}
              selectedDate={values.estimated_delivery_time}
              task={taskData as Task}
            />
          )}
        </Form>
      )}
    </Formik>
  );
};

type SalesTaxTask = {
  uuid: string;
  assigned_team?: { uuid?: string; name?: string };
};

export const ServiceTeamColumn = ({
  taskData,
  tracker,
}: {
  taskData: Task | EntityTask | Task1120Tracker | SalesTaxTask;
  tracker?: typeof SALES_TAX;
}) => {
  const { alertToast, successToast } = useToast();
  const [tempServiceTeamId, setTempServiceTeamId] = useState<string | null>(
    null
  );
  const { isAdmin } = useRoleBasedView();
  const { data: teamOptions = [], isLoading } = useGetAllInkleCPATeamsQuery(
    {
      accessibleTeams: "CPA_TEAM",
    },
    { skip: !isAdmin }
  );
  const confirmModal = useModal();

  const query = useQuery();

  const selectedTab = query.get("tab") || TASK_TYPE.FILINGS;

  const [updateTaskAssigneeAdmin, { isLoading: isUpdatingTaskAdmin }] =
    useUpdateTaskAssigneeAdminMutation();

  const [assignSalesTaxTask, { isLoading: isUpdatingSalesTaxTask }] =
    useAssignTaskMutation();

  const onServiceTeamChange = (value?: string | null) => {
    setTempServiceTeamId(value || null);
    confirmModal.open();
  };

  const onServiceTeamChangeConfirm = async () => {
    try {
      if (tracker === SALES_TAX) {
        const payload = {
          task_id: taskData?.uuid || "",
          service_team_id: tempServiceTeamId || "",
          task_type: selectedTab as TaskTrackerType,
          is_remove_service_team: !tempServiceTeamId,
        };
        await assignSalesTaxTask({
          payload,
        }).unwrap();
      } else {
        await updateTaskAssigneeAdmin({
          taskId: taskData?.uuid || "",
          serviceTeamId: tempServiceTeamId || "",
          removeServiceTeam: tempServiceTeamId ? false : true,
          preparerId: "",
          removePreparer: true,
        }).unwrap();
      }
      confirmModal.close();
      successToast({ message: "Updated" });
      setTempServiceTeamId(null);
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  const handleClose = () => {
    setTempServiceTeamId(null);
    confirmModal.close();
  };

  return (
    <div className="t-group t-select-none" onClick={(e) => e.stopPropagation()}>
      <Combobox
        block
        id={taskData.uuid}
        size="small"
        menuPlacement="auto"
        isDisabled={!taskData.uuid}
        onChange={(prop: SingleValue<OptionData> | MultiValue<OptionData>) =>
          onServiceTeamChange((prop as SingleValue<OptionData>)?.value)
        }
        components={{
          Control: TransactionComboboxControl,
          DropdownIndicator: DropdownIndicator,
          ClearIndicator: TransactionComboboxClearIndicator,
        }}
        isLoading={isUpdatingTaskAdmin || isLoading}
        options={teamOptions.map((option) => {
          return {
            label: option.name,
            value: option.uuid,
            data: option.name,
          };
        })}
        value={
          taskData?.assigned_team?.name
            ? {
                label: taskData?.assigned_team?.name as string,
                value: taskData?.assigned_team?.uuid as string,
              }
            : null
        }
        menuPortalTarget={document.body}
        styles={{
          menu: (base) => ({
            ...base,
            width: 160,
          }),
        }}
      />
      {confirmModal.isOpen && (
        <ServiceTeamChangeModal
          isOpen
          onClose={handleClose}
          serviceTeamId={tempServiceTeamId}
          onSubmit={onServiceTeamChangeConfirm}
          isLoading={isUpdatingTaskAdmin || isUpdatingSalesTaxTask}
        />
      )}
    </div>
  );
};

type SalesTaxTaskType = {
  uuid: string;
  assigned_team?: { uuid?: string; name?: string };
  assigned_to?: { name?: string; uuid?: string };
};

export const PreparerColumn = ({
  taskData,
  tracker,
  season,
  suggestPreparer = false,
}: {
  taskData: Task | Task1120Tracker | SalesTaxTaskType;
  tracker?: typeof SALES_TAX;
  season?: string | number | null;
  suggestPreparer?: boolean;
}) => {
  const { alertToast, successToast } = useToast();
  const { isCpa, isAdmin, isCustomer } = useRoleBasedView();
  const serviceTeamId = isAdmin ? taskData?.assigned_team?.uuid : null;
  const serviceTeamIds = serviceTeamId
    ?.split(",")
    .filter((id) => validate(id))
    .join(",");
  const { data: teamMembers = [], isLoading } = useGetServiceTeamQuery(
    {
      serviceTeamId: serviceTeamIds,
      suggest_preparer: suggestPreparer,
    },
    { skip: isCustomer }
  );
  const [tempPreparerId, setTempPreparerId] = useState<string | null>(null);
  const confirmModal = useModal();

  const [updateTaskAssigneeAdmin, { isLoading: isUpdatingTaskAdmin }] =
    useUpdateTaskAssigneeAdminMutation();

  const [updateTaskAssigneeProvider, { isLoading: isUpdatingTaskProvider }] =
    useUpdateTaskAssigneeProviderMutation();

  const [assignSalesTaxTask, { isLoading: isUpdatingSalesTaxTask }] =
    useAssignTaskMutation();

  const query = useQuery();

  const selectedTab = query.get("tab") || TASK_TYPE.FILINGS;

  const onPreparerChange = (value?: string | null) => {
    setTempPreparerId(value || null);
    confirmModal.open();
  };

  const onPreparerChangeConfirm = async () => {
    try {
      if (isAdmin) {
        if (tracker === SALES_TAX) {
          await assignSalesTaxTask({
            payload: {
              task_id: taskData?.uuid!,
              profile_id: tempPreparerId!,
              task_type: selectedTab as TaskTrackerType,
              is_remove_profile_id: !tempPreparerId,
            },
          }).unwrap();
        } else {
          await updateTaskAssigneeAdmin({
            taskId: taskData?.uuid,
            serviceTeamId: taskData?.assigned_team?.uuid as string,
            removeServiceTeam: false,
            preparerId: tempPreparerId,
            removePreparer: tempPreparerId ? false : true,
          }).unwrap();
        }
      } else if (isCpa) {
        await updateTaskAssigneeProvider({
          taskId: taskData?.uuid,
          preparerId: tempPreparerId,
          removePreparer: tempPreparerId ? false : true,
        }).unwrap();
      }
      successToast({ message: "Updated" });
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  const handleClose = () => {
    setTempPreparerId(null);
    confirmModal.close();
  };

  const preparerName = teamMembers.find(
    (member) => member.uuid === tempPreparerId
  )?.name;

  const options = useMemo(
    () =>
      teamMembers.map(({ name, uuid, is_suggested }) => ({
        label: name,
        value: uuid,
        data: is_suggested as unknown as string,
      })),
    [teamMembers]
  );

  const formatPreparerOption = (option: OptionData) => (
    <div className="t-flex t-items-center t-justify-between t-gap-2">
      <span>{option.label}</span>
      {option.data && (
        <TagComp tagType="green" rounded>
          Fewer Leads
        </TagComp>
      )}
    </div>
  );

  return (
    <div className="t-group t-select-none" onClick={(e) => e.stopPropagation()}>
      <Combobox
        size="small"
        menuPlacement="auto"
        creatable={false}
        isLoading={
          isUpdatingTaskAdmin ||
          isLoading ||
          isUpdatingTaskProvider ||
          isUpdatingSalesTaxTask
        }
        isDisabled={!Boolean(taskData?.assigned_team?.uuid) && isAdmin}
        onChange={(prop: SingleValue<OptionData> | MultiValue<OptionData>) =>
          onPreparerChange((prop as SingleValue<OptionData>)?.value)
        }
        components={{
          Control: TransactionComboboxControl,
          DropdownIndicator: DropdownIndicator,
          ClearIndicator: TransactionComboboxClearIndicator,
        }}
        options={options}
        formatOptionLabel={formatPreparerOption}
        value={
          taskData?.assigned_to?.name
            ? {
                label: taskData?.assigned_to?.name as string,
                value: taskData?.assigned_to?.uuid as string,
              }
            : null
        }
        menuPortalTarget={document.body}
        styles={{
          menu: (base) => ({
            ...base,
            width: 160,
          }),
        }}
      />
      {confirmModal.isOpen && (
        <PreparerChangeConfirm
          isOpen
          close={handleClose}
          preparerName={preparerName}
          onSubmit={onPreparerChangeConfirm}
          isLoading={isUpdatingTaskAdmin || isUpdatingSalesTaxTask}
        />
      )}
    </div>
  );
};

export const ReviewerColumn = ({
  taskData,
}: {
  taskData: Task | Task1120Tracker;
}) => {
  const { alertToast, successToast } = useToast();
  const { isAdmin, isCustomer } = useRoleBasedView();
  const serviceTeamId = isAdmin ? taskData?.assigned_team?.uuid : null;
  const serviceTeamIds = serviceTeamId
    ?.split(",")
    .filter((id) => validate(id))
    .join(",");
  const { data: teamMembers = [], isLoading } = useGetServiceTeamQuery(
    {
      serviceTeamId: serviceTeamIds,
    },
    { skip: isCustomer }
  );
  const [tempReviewerId, setTempReviewerId] = useState<string | null>(null);
  const confirmModal = useModal();

  const [updateTaskAssigneeAdmin, { isLoading: isUpdatingTaskAdmin }] =
    useUpdateTaskAssigneeAdminMutation();

  const onReviewerChange = (value?: string | null) => {
    setTempReviewerId(value || null);
    confirmModal.open();
  };

  const onReviewerChangeConfirm = async () => {
    try {
      await updateTaskAssigneeAdmin({
        taskId: taskData?.uuid,
        reviewerId: tempReviewerId || undefined,
        removeReviewer: !tempReviewerId,
      }).unwrap();
      successToast({ message: "Updated" });
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  const handleClose = () => {
    setTempReviewerId(null);
    confirmModal.close();
  };

  const reviewerName = teamMembers.find(
    (member) => member.uuid === tempReviewerId
  )?.name;

  const confirmationText = reviewerName ? (
    <>
      Are you sure you want to assign this task to <b>{reviewerName}</b> as
      reviewer?
    </>
  ) : (
    "Are you sure you want to unassign the reviewer from this task?"
  );

  return (
    <div className="t-group t-select-none" onClick={(e) => e.stopPropagation()}>
      <Combobox
        size="small"
        menuPlacement="auto"
        creatable={false}
        isLoading={isUpdatingTaskAdmin || isLoading}
        isDisabled={!Boolean(taskData?.assigned_team?.uuid) && isAdmin}
        onChange={(prop: SingleValue<OptionData> | MultiValue<OptionData>) =>
          onReviewerChange((prop as SingleValue<OptionData>)?.value)
        }
        components={{
          Control: TransactionComboboxControl,
          DropdownIndicator: DropdownIndicator,
          ClearIndicator: TransactionComboboxClearIndicator,
        }}
        options={teamMembers.map(({ name, uuid }) => ({
          label: name,
          value: uuid,
          data: name,
        }))}
        value={
          taskData?.reviewer?.name
            ? {
                label: taskData?.reviewer?.name as string,
                value: taskData?.reviewer?.uuid as string,
              }
            : null
        }
        menuPortalTarget={document.body}
        styles={{
          menu: (base) => ({
            ...base,
            width: 160,
          }),
        }}
      />
      {confirmModal.isOpen && (
        <Modal.Root open onOpenChange={handleClose}>
          <Modal.Content size="small">
            <Modal.Header>
              <Modal.Title>
                {reviewerName ? "Assign" : "Unassign"} Reviewer
              </Modal.Title>
              <Modal.Close />
            </Modal.Header>
            <Modal.Body className="t-text-body-sm">
              {confirmationText}
            </Modal.Body>
            <Modal.FooterButtonGroup>
              <Modal.RawClose asChild>
                <Button>Cancel</Button>
              </Modal.RawClose>
              <Button
                customType={reviewerName ? "primary" : "danger"}
                isLoading={isUpdatingTaskAdmin}
                disabled={isUpdatingTaskAdmin}
                onClick={onReviewerChangeConfirm}
              >
                Yes
              </Button>
            </Modal.FooterButtonGroup>
          </Modal.Content>
        </Modal.Root>
      )}
    </div>
  );
};

const STAGE_KEY_COLORS: Record<string, TagColorType> = {
  [STAGE_KEY_MISSING_INFORMATION]: "red",
  [STAGE_KEY_MI_RAISED_WITH_BOOKS]: "red",
  [STAGE_KEY_REVIEW_IN_PROGRESS]: "yellow",
  [STAGE_KEY_REVIEW_IN_FINAL]: "yellow",
  [STAGE_KEY_DRAFT_SHARED]: "yellow",
  [STAGE_KEY_BOOKS_PENDING]: "orange",
  [STATUS_ON_HOLD]: "red",
};

export const TaskStateDropdown = ({ task }: { task: Task }) => {
  const [updateState, { isLoading: isUpdateLoading }] =
    useUpdateStateMutation();
  const [setOnHold, { isLoading: isSetOnHoldLoading }] = useSetOnHoldMutation();

  const [updateTaskAssigneeForAdmin, { isLoading: isUpdatingAdmin }] =
    useUpdateTaskAssigneeAdminMutation();
  const [updateTaskAssigneeForProvider, { isLoading: isUpdatingProvider }] =
    useUpdateTaskAssigneeProviderMutation();
  const { isAdmin } = useRoleBasedView();
  const isLoading =
    isUpdateLoading ||
    isSetOnHoldLoading ||
    isUpdatingAdmin ||
    isUpdatingProvider;

  type PendingOption = {
    uuid: string;
    stageUuid: string;
    label: string;
    stageKey: string;
    isOnHoldOption: boolean;
    customerLabel?: string;
    trackerStatus?: string;
  };

  const [pending, setPending] = useState<PendingOption | null>(null);
  const [completedPending, setCompletedPending] =
    useState<PendingOption | null>(null);

  const booksStatus = useBooksTaskStatus({ task });
  if (booksStatus.isBooksTask) {
    return (
      <BooksTaskStatusCombobox
        task={task}
        status={booksStatus}
        isVariablePricing={
          task.client_progress ? false : !task.is_pricing_fixed
        }
      />
    );
  }

  const isNewWorkflow = Boolean(task.client_progress);
  const currentIsOnHold = Boolean(task.client_progress?.is_on_hold);
  const currentTrackerStatus = task.tracker_global_status;

  const ON_HOLD_SENTINEL = "__ON_HOLD__";

  const onHoldOption = {
    uuid: ON_HOLD_SENTINEL,
    stageUuid: ON_HOLD_SENTINEL,
    label: "On Hold",
    stageKey: STATUS_ON_HOLD,
    isCurrent: currentIsOnHold,
    isOnHoldOption: true,
    customerLabel: undefined,
    trackerStatus: undefined,
  };

  const buildNewWorkflowOptions = () => {
    const stageOptions = (task.client_progress?.stages ?? []).flatMap((s) => {
      const isInQueueStage = s.key === STAGE_KEY_IN_QUEUE;
      const isPrepInProgressStage = s.key === STAGE_KEY_PREP_IN_PROGRESS;
      const isReviewInProgressStage = s.key === STAGE_KEY_REVIEW_IN_PROGRESS;
      const isMissingInfoStage = s.key === STAGE_KEY_MISSING_INFORMATION;
      const isDraftSharedStage = s.key === STAGE_KEY_DRAFT_SHARED;
      const isPreparerAssignedStage = s.key === STAGE_KEY_PREPARER_ASSIGNED;

      if (isInQueueStage) {
        const is1120 = currentTrackerStatus !== null;
        return [
          {
            uuid: s.uuid + (is1120 ? ":BKSPND" : ""),
            stageUuid: s.uuid,
            label: is1120 ? "Books Pending" : s.label,
            stageKey: is1120 ? STAGE_KEY_BOOKS_PENDING : STAGE_KEY_IN_QUEUE,
            isCurrent: !currentIsOnHold && s.is_current,
            isCurrentStage: s.is_current,
            isOnHoldOption: false,
            customerLabel: s.label,
            trackerStatus: is1120 ? FILTER_BOOKS_PENDING : undefined,
          },
        ];
      }
      if (isPrepInProgressStage) {
        const isMiCurrent =
          s.is_current &&
          currentTrackerStatus === TRACKER_STATUS_NAME_MI_RAISED_WITH_BOOKS;
        return [
          {
            uuid: s.uuid + ":PREP",
            stageUuid: s.uuid,
            label: s.label,
            stageKey: STAGE_KEY_PREP_IN_PROGRESS,
            isCurrent: !currentIsOnHold && s.is_current && !isMiCurrent,
            isCurrentStage: s.is_current && !isMiCurrent,
            isOnHoldOption: false,
            customerLabel: undefined,
            trackerStatus: undefined,
          },
          {
            uuid: s.uuid + ":MIBKS",
            stageUuid: s.uuid,
            label: "MI raised with books",
            stageKey: STAGE_KEY_MI_RAISED_WITH_BOOKS,
            isCurrent: !currentIsOnHold && isMiCurrent,
            isCurrentStage: isMiCurrent,
            isOnHoldOption: false,
            customerLabel: s.label,
            trackerStatus: STATUS_MI_RAISED_WITH_BOOKS,
          },
        ];
      }
      if (isReviewInProgressStage) {
        const isFinalReview =
          s.is_current &&
          currentTrackerStatus === TRACKER_STATUS_NAME_IN_FINAL_REVIEW;
        const isInternalReview =
          s.is_current &&
          currentTrackerStatus === TRACKER_STATUS_NAME_INTERNAL_REVIEW;
        return [
          {
            uuid: s.uuid + ":IR",
            stageUuid: s.uuid,
            label: "In Review",
            stageKey: STAGE_KEY_REVIEW_IN_PROGRESS,
            isCurrent: !currentIsOnHold && isInternalReview,
            isCurrentStage: isInternalReview,
            isOnHoldOption: false,
            customerLabel: s.label,
            trackerStatus: STATUS_INTERNAL_REVIEW,
          },
          {
            uuid: s.uuid + ":FIR",
            stageUuid: s.uuid,
            label: "In Final Review",
            stageKey: STAGE_KEY_REVIEW_IN_FINAL,
            isCurrent: !currentIsOnHold && isFinalReview,
            isCurrentStage: isFinalReview,
            isOnHoldOption: false,
            customerLabel: s.label,
            trackerStatus: STATUS_IN_FINAL_REVIEW,
          },
        ];
      }
      let stageLabel = s.label;
      if (isMissingInfoStage) stageLabel = "MI Raised with Client";
      if (isDraftSharedStage) stageLabel = "Draft shared with client";
      if (isPreparerAssignedStage && currentTrackerStatus !== null)
        stageLabel = "Ready to be picked";

      const hasCustomerLabel = isMissingInfoStage || isDraftSharedStage;
      const stageCustomerLabel = hasCustomerLabel ? s.label : undefined;

      let stageTrackerStatus: string | undefined;
      if (isMissingInfoStage) stageTrackerStatus = STATUS_INFORMATION_REQUIRED;
      if (isDraftSharedStage) stageTrackerStatus = STATUS_DRAFT_SHARED;

      return [
        {
          uuid: s.uuid,
          stageUuid: s.uuid,
          label: stageLabel,
          stageKey: s.key,
          isCurrent: currentIsOnHold ? false : s.is_current,
          isCurrentStage: s.is_current,
          isOnHoldOption: false,
          customerLabel: stageCustomerLabel,
          trackerStatus: stageTrackerStatus,
        },
      ];
    });

    if (currentIsOnHold) {
      const currentIdx = stageOptions.findLastIndex((o) => o.isCurrentStage);
      const insertAt = currentIdx >= 0 ? currentIdx + 1 : stageOptions.length;
      return [
        ...stageOptions.slice(0, insertAt),
        onHoldOption,
        ...stageOptions.slice(insertAt),
      ];
    }
    return [onHoldOption, ...stageOptions];
  };

  const options = isNewWorkflow
    ? buildNewWorkflowOptions()
    : (task.task_states ?? []).map((s) => ({
        uuid: s.uuid,
        stageUuid: s.uuid,
        label: s.name,
        stageKey: s.type_str as string,
        isCurrent: task.state === s.name,
        isOnHoldOption: false,
        customerLabel: undefined,
        trackerStatus: undefined,
      }));

  if (!options.length) return null;

  const currentOption = options.find((o) => o.isCurrent);

  const getTagColor = (stageKey: string): TagColorType => {
    if (STAGE_KEY_COLORS[stageKey]) return STAGE_KEY_COLORS[stageKey];
    if (isNewWorkflow)
      return (ClientStageTagTypes[stageKey] as TagColorType) || "blue";
    return (TaskStateTagTypes[stageKey] as TagColorType) || "blue";
  };

  const toChipOption = (o: (typeof options)[number]) => ({
    label: (
      <TagComp icon={false} tagType={getTagColor(o.stageKey)} rounded>
        {o.label}
      </TagComp>
    ),
    value: o.uuid,
  });

  const handleChange = (
    prop: SingleValue<OptionData> | MultiValue<OptionData>
  ) => {
    const value = (prop as SingleValue<OptionData>)?.value;
    const selected = options.find((o) => o.uuid === value);
    if (!selected) return;
    if (selected.stageKey === COMPLETED) {
      setCompletedPending(selected);
    } else {
      setPending(selected);
    }
  };

  const handleConfirm = async (description?: string) => {
    if (!pending) return;
    if (pending.isOnHoldOption) {
      await setOnHold({ taskId: task.uuid, description: description ?? "" });
    } else {
      await updateState({ taskId: task.uuid, newStateId: pending.stageUuid });
    }
    if (pending.trackerStatus) {
      const updateTaskAssignee = isAdmin
        ? updateTaskAssigneeForAdmin
        : updateTaskAssigneeForProvider;
      await updateTaskAssignee({
        taskId: task.uuid,
        form_1120_global_status: pending.trackerStatus,
      });
    }
    setPending(null);
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <ConditionalToolTip
        condition={
          currentIsOnHold && (
            <div className="t-text-center t-break-words t-hyphen-auto t-max-w-[500px]">
              {task.on_hold_reason}
            </div>
          )
        }
      >
        <div>
          <Combobox
            block
            size="small"
            isDisabled={isLoading}
            onChange={handleChange}
            components={{
              Control: TransactionComboboxControl,
              DropdownIndicator,
              ClearIndicator: () => null,
            }}
            options={options.map(toChipOption)}
            value={currentOption ? toChipOption(currentOption) : null}
            menuPortalTarget={document.body}
            styles={{
              menu: (base) => ({ ...base, width: 200 }),
            }}
          />
        </div>
      </ConditionalToolTip>
      {pending && (
        <TaskStateChangeModal
          isOpen
          onClose={() => setPending(null)}
          onConfirm={handleConfirm}
          targetLabel={pending.label}
          customerLabel={pending.customerLabel}
          isOnHold={pending.isOnHoldOption}
          isLoading={isLoading}
        />
      )}
      {completedPending && (
        <UpdateTaskPrice
          show
          closeModal={() => setCompletedPending(null)}
          setShow={() => setCompletedPending(null)}
          newStateId={completedPending.stageUuid}
          groupId={task.group_uuid}
          taskId={task.uuid}
          task={task}
          isVariablePricing={isNewWorkflow ? false : !task.is_pricing_fixed}
          entityId={task.entity?.uuid}
        />
      )}
    </div>
  );
};

export const AmendmentStatusLabel = ({
  label,
  amendmentNumber,
}: {
  label: string;
  amendmentNumber?: number;
}) => {
  if (!amendmentNumber) return <>{label}</>;

  return (
    <span className="t-flex t-items-center t-gap-2">
      <span>Amendment {amendmentNumber}</span>
      <span>•</span>
      <span>{label}</span>
    </span>
  );
};

export const TaskStateDropdownTag = ({ task }: { task: Task }) => {
  const [updateState, { isLoading: isUpdateLoading }] =
    useUpdateStateMutation();
  const [setOnHold, { isLoading: isSetOnHoldLoading }] = useSetOnHoldMutation();

  const [updateTaskAssigneeForAdmin, { isLoading: isUpdatingAdmin }] =
    useUpdateTaskAssigneeAdminMutation();
  const [updateTaskAssigneeForProvider, { isLoading: isUpdatingProvider }] =
    useUpdateTaskAssigneeProviderMutation();
  const { isAdmin } = useRoleBasedView();
  const isLoading =
    isUpdateLoading ||
    isSetOnHoldLoading ||
    isUpdatingAdmin ||
    isUpdatingProvider;

  type TagPendingOption = {
    uuid: string;
    stageUuid: string;
    label: string;
    stageKey: string;
    isOnHoldOption: boolean;
    customerLabel?: string;
    trackerStatus?: string;
  };

  const [pending, setPending] = useState<TagPendingOption | null>(null);
  const [completedPending, setCompletedPending] =
    useState<TagPendingOption | null>(null);

  const booksStatus = useBooksTaskStatus({ task });
  if (booksStatus.isBooksTask) {
    return <BooksTaskStatusTag task={task} status={booksStatus} />;
  }

  const isNewWorkflow = Boolean(task.client_progress);
  const currentIsOnHold = Boolean(task.client_progress?.is_on_hold);
  const currentTrackerStatus = task.tracker_global_status;

  if (!isNewWorkflow) return null;
  const ON_HOLD_SENTINEL = "__ON_HOLD__";

  const onHoldOption = {
    uuid: ON_HOLD_SENTINEL,
    stageUuid: ON_HOLD_SENTINEL,
    label: "On Hold",
    stageKey: STATUS_ON_HOLD,
    isCurrent: currentIsOnHold,
    isOnHoldOption: true,
    customerLabel: undefined,
    trackerStatus: undefined,
  };

  const buildNewWorkflowOptions = () => {
    const stageOptions = (task.client_progress?.stages ?? []).flatMap((s) => {
      const isInQueueStage = s.key === STAGE_KEY_IN_QUEUE;
      const isPrepInProgressStage = s.key === STAGE_KEY_PREP_IN_PROGRESS;
      const isReviewInProgressStage = s.key === STAGE_KEY_REVIEW_IN_PROGRESS;
      const isMissingInfoStage = s.key === STAGE_KEY_MISSING_INFORMATION;
      const isDraftSharedStage = s.key === STAGE_KEY_DRAFT_SHARED;
      const isPreparerAssignedStage = s.key === STAGE_KEY_PREPARER_ASSIGNED;

      if (isInQueueStage) {
        const is1120 = currentTrackerStatus !== null;
        return [
          {
            uuid: s.uuid + (is1120 ? ":BKSPND" : ""),
            stageUuid: s.uuid,
            label: is1120 ? "Books Pending" : s.label,
            stageKey: is1120 ? STAGE_KEY_BOOKS_PENDING : STAGE_KEY_IN_QUEUE,
            isCurrent: !currentIsOnHold && s.is_current,
            isCurrentStage: s.is_current,
            isOnHoldOption: false,
            customerLabel: s.label,
            trackerStatus: is1120 ? FILTER_BOOKS_PENDING : undefined,
          },
        ];
      }
      if (isPrepInProgressStage) {
        const isMiCurrent =
          s.is_current &&
          currentTrackerStatus === TRACKER_STATUS_NAME_MI_RAISED_WITH_BOOKS;
        return [
          {
            uuid: s.uuid + ":PREP",
            stageUuid: s.uuid,
            label: s.label,
            stageKey: STAGE_KEY_PREP_IN_PROGRESS,
            isCurrent: !currentIsOnHold && s.is_current && !isMiCurrent,
            isCurrentStage: s.is_current && !isMiCurrent,
            isOnHoldOption: false,
            customerLabel: undefined,
            trackerStatus: undefined,
          },
          {
            uuid: s.uuid + ":MIBKS",
            stageUuid: s.uuid,
            label: "MI raised with books",
            stageKey: STAGE_KEY_MI_RAISED_WITH_BOOKS,
            isCurrent: !currentIsOnHold && isMiCurrent,
            isCurrentStage: isMiCurrent,
            isOnHoldOption: false,
            customerLabel: s.label,
            trackerStatus: STATUS_MI_RAISED_WITH_BOOKS,
          },
        ];
      }
      if (isReviewInProgressStage) {
        const isFinalReview =
          s.is_current &&
          currentTrackerStatus === TRACKER_STATUS_NAME_IN_FINAL_REVIEW;
        const isInternalReview =
          s.is_current &&
          currentTrackerStatus === TRACKER_STATUS_NAME_INTERNAL_REVIEW;
        return [
          {
            uuid: s.uuid + ":IR",
            stageUuid: s.uuid,
            label: "In Review",
            stageKey: STAGE_KEY_REVIEW_IN_PROGRESS,
            isCurrent: !currentIsOnHold && isInternalReview,
            isCurrentStage: isInternalReview,
            isOnHoldOption: false,
            customerLabel: s.label,
            trackerStatus: STATUS_INTERNAL_REVIEW,
          },
          {
            uuid: s.uuid + ":FIR",
            stageUuid: s.uuid,
            label: "In Final Review",
            stageKey: STAGE_KEY_REVIEW_IN_FINAL,
            isCurrent: !currentIsOnHold && isFinalReview,
            isCurrentStage: isFinalReview,
            isOnHoldOption: false,
            customerLabel: s.label,
            trackerStatus: STATUS_IN_FINAL_REVIEW,
          },
        ];
      }
      let stageLabel = s.label;
      if (isMissingInfoStage) stageLabel = "MI Raised with Client";
      if (isDraftSharedStage) stageLabel = "Draft shared with client";
      if (isPreparerAssignedStage && currentTrackerStatus !== null)
        stageLabel = "Ready to be picked";

      const hasCustomerLabel = isMissingInfoStage || isDraftSharedStage;
      const stageCustomerLabel = hasCustomerLabel ? s.label : undefined;

      let stageTrackerStatus: string | undefined;
      if (isMissingInfoStage) stageTrackerStatus = STATUS_INFORMATION_REQUIRED;
      if (isDraftSharedStage) stageTrackerStatus = STATUS_DRAFT_SHARED;

      return [
        {
          uuid: s.uuid,
          stageUuid: s.uuid,
          label: stageLabel,
          stageKey: s.key,
          isCurrent: currentIsOnHold ? false : s.is_current,
          isCurrentStage: s.is_current,
          isOnHoldOption: false,
          customerLabel: stageCustomerLabel,
          trackerStatus: stageTrackerStatus,
        },
      ];
    });

    if (currentIsOnHold) {
      const currentIdx = stageOptions.findLastIndex((o) => o.isCurrentStage);
      const insertAt = currentIdx >= 0 ? currentIdx + 1 : stageOptions.length;
      return [
        ...stageOptions.slice(0, insertAt),
        onHoldOption,
        ...stageOptions.slice(insertAt),
      ];
    }
    return [onHoldOption, ...stageOptions];
  };

  const options = isNewWorkflow
    ? buildNewWorkflowOptions()
    : (task.task_states ?? []).map((s) => ({
        uuid: s.uuid,
        stageUuid: s.uuid,
        label: s.name,
        stageKey: s.type_str as string,
        isCurrent: task.state === s.name,
        isOnHoldOption: false,
        customerLabel: undefined,
        trackerStatus: undefined,
      }));

  if (!options.length) return null;

  const currentOption = options.find((o) => o.isCurrent);

  const getTagColor = (stageKey: string): TagColorType => {
    if (STAGE_KEY_COLORS[stageKey]) return STAGE_KEY_COLORS[stageKey];
    if (isNewWorkflow)
      return (ClientStageTagTypes[stageKey] as TagColorType) || "blue";
    return (TaskStateTagTypes[stageKey] as TagColorType) || "blue";
  };

  const handleConfirm = async (description?: string) => {
    if (!pending) return;
    if (pending.isOnHoldOption) {
      await setOnHold({ taskId: task.uuid, description: description ?? "" });
    } else {
      await updateState({ taskId: task.uuid, newStateId: pending.stageUuid });
    }
    if (pending.trackerStatus) {
      const updateTaskAssignee = isAdmin
        ? updateTaskAssigneeForAdmin
        : updateTaskAssigneeForProvider;
      await updateTaskAssignee({
        taskId: task.uuid,
        form_1120_global_status: pending.trackerStatus,
      });
    }
    setPending(null);
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Dropdown.Root>
        <Dropdown.Trigger
          asChild
          disabled={isLoading || currentOption?.stageKey === COMPLETED}
        >
          <span>
            <TagComp
              icon={false}
              tagType={getTagColor(currentOption?.stageKey ?? "")}
              size="xsmall"
            >
              <span className="t-flex t-items-center t-gap-1">
                <AmendmentStatusLabel
                  label={currentOption?.label ?? "—"}
                  amendmentNumber={task.client_progress?.amendment_number}
                />
                <div className="t-rotate-90 t-group-data-state-open:-t-rotate-90">
                  <ArrowRight stroke="1.5" color="currentColor" size="12" />
                </div>
              </span>
            </TagComp>
          </span>
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content className="t-mt-2">
            {options.map((o) => (
              <Dropdown.Item
                key={o.uuid}
                onSelect={() =>
                  o.stageKey === COMPLETED
                    ? setCompletedPending(o)
                    : setPending(o)
                }
                className={o.isCurrent ? "t-bg-purple-0" : undefined}
              >
                <TagComp icon={false} tagType={getTagColor(o.stageKey)} rounded>
                  {o.label}
                </TagComp>
              </Dropdown.Item>
            ))}
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
      {pending && (
        <TaskStateChangeModal
          isOpen
          onClose={() => setPending(null)}
          onConfirm={handleConfirm}
          targetLabel={pending.label}
          customerLabel={pending.customerLabel}
          isOnHold={pending.isOnHoldOption}
          isLoading={isLoading}
        />
      )}
      {completedPending && (
        <UpdateTaskPrice
          show
          closeModal={() => setCompletedPending(null)}
          setShow={() => setCompletedPending(null)}
          newStateId={completedPending.stageUuid}
          groupId={task.group_uuid}
          taskId={task.uuid}
          task={task}
          isVariablePricing={false}
          entityId={task.entity?.uuid}
        />
      )}
    </div>
  );
};

const SELECTION_COL_WIDTH = 52;
const GROUP_NAME_COL_WIDTH = 200;

const columnHelper = createColumnHelper<Task>();

export const ChatSlider = ({
  openTaskChat,
  ...props
}: CellContext<Task, string> & {
  channelUnreadMap: Record<string, number>;
  openTaskChat: (taskId: string, taskSliderTab: TaskSliderTabs) => void;
}) => {
  const defaultChannelId = props.getValue();
  const defaultUnreadCount = props.channelUnreadMap[defaultChannelId];

  const [unreadCount, setUnreadCount] = useState<number>(defaultUnreadCount);
  const { client } = useChatContext();

  useEffect(() => {
    try {
      const channel = client.channel("messaging", defaultChannelId);
      const readSub = channel.on("message.read", (event) => {
        setUnreadCount(channel.countUnread());
      });

      const newSub = channel.on("message.new", (event) => {
        setUnreadCount(channel.countUnread());
      });

      return () => {
        readSub.unsubscribe();
        newSub.unsubscribe();
      };
    } catch (error) {}
  }, [defaultChannelId]);

  const onClick: HTMLAttributes<HTMLButtonElement>["onClick"] = (e) => {
    e.stopPropagation();
    openTaskChat(props.row.original.uuid, TASK_SLIDER_TABS.CHAT);
  };

  return (
    <div>
      <Button customType="ghost_icon" size="xsmall" onClick={onClick}>
        <div className="t-flex t-items-center t-justify-center">
          {Boolean(unreadCount) && unreadCount > 0 && (
            <span className="t-border-solid t-border t-border-surface t-absolute t-right-1 t-top-1 t-h-4 t-w-4 t-rounded-full t-z-10 t-overflow-hidden">
              <span className="t-bg-red-50 t-text-caption t-h-4 t-w-4 t-text-white t-flex t-items-center t-justify-center">
                {unreadCount}
              </span>
            </span>
          )}
          <Chat />
        </div>
      </Button>
    </div>
  );
};

export const taskColumns = ({
  isAdmin,
  isCpa,
  isServiceSuperAdmin,
  tags,
  channelUnreadMap,
  openTaskChat,
  isForeignCA,
  showTotalTxnColoumn,
  showConnectionColoumn,
  isCustomer,
}: {
  isServiceSuperAdmin: boolean;
  isAdmin: boolean;
  isCpa: boolean;
  tags: Tag[];
  channelUnreadMap: Record<string, number>;
  openTaskChat: (taskId: string, taskSliderTab: TaskSliderTabs) => void;
  isForeignCA: boolean;
  showTotalTxnColoumn?: boolean;
  showConnectionColoumn?: boolean;
  isCustomer?: boolean;
}) => {
  const banksConnections = showConnectionColoumn
    ? [
        columnHelper.accessor("total_bank_connections", {
          cell: ({ row }) => {
            const { total_bank_connections, active_bank_connections } =
              row.original;

            if (total_bank_connections === 0 && active_bank_connections === 0)
              return <div className="t-text-center t-text-text-60">-</div>;

            return (
              <div className="t-text-center t-text-text-60">
                <span className="t-text-dark_green-50">
                  {active_bank_connections ?? "-"}
                </span>
                /{total_bank_connections ?? "-"}
              </div>
            );
          },
          header: "Connection",
          size: 16,
          minSize: 119,
        }),
      ]
    : [];

  const transactions = showTotalTxnColoumn
    ? [
        columnHelper.accessor("number_of_transactions", {
          cell: ({ row }) => {
            const { number_of_transactions } = row.original;

            return (
              <div className="t-text-center t-text-text-60">
                {number_of_transactions ?? "-"}
              </div>
            );
          },
          header: "Transactions",
          size: 16,
          minSize: 119,
        }),
      ]
    : [];

  const formationType = [
    columnHelper.accessor("entity.formation_type.name", {
      cell: (info) => {
        return (
          <div className="t-text-text-60 t-text-body-sm">
            {info.getValue() || "-"}
          </div>
        );
      },
      header: "Formation type",
      size: 16,
      minSize: 150,
    }),
  ];

  const serviceTeamColumn = isAdmin
    ? [
        columnHelper.accessor("uuid", {
          cell: ({ row }) => <ServiceTeamColumn taskData={row.original} />,
          header: "Service Team",
          size: 16,
          minSize: 125,
        }),
      ]
    : [];

  const preparerColumn =
    isAdmin || isServiceSuperAdmin
      ? [
          columnHelper.accessor("uuid", {
            cell: ({ row }) => <PreparerColumn taskData={row.original} />,
            header: "Preparer",
            size: 15,
            minSize: 125,
          }),
        ]
      : [];

  const deadlineColumn = isCpa
    ? [
        columnHelper.accessor("deadline", {
          cell: (info) => {
            const deadline = info.getValue();
            const daysDifference = deadline
              ? dayjs(deadline).diff(dayjs(), "day")
              : "";
            const rowData = info.row.original;
            const canUpdateDeadline =
              !isCustomer &&
              (rowData.base_task_key === STATE_FILING ||
                rowData.base_task_key === AD_HOC);

            return (
              <div className="t-flex t-flex-col">
                {deadline ? (
                  <div className="t-flex t-gap-1 t-items-center">
                    <div className="t-text-body-sm">{formatDate(deadline)}</div>
                    {canUpdateDeadline && (
                      <span onClick={(e) => e.stopPropagation()}>
                        <UpdateTaskDeadline rowData={rowData} />
                      </span>
                    )}
                  </div>
                ) : (
                  <>
                    {canUpdateDeadline ? (
                      <span onClick={(e) => e.stopPropagation()}>
                        <AddTaskDeadline rowData={rowData} />
                      </span>
                    ) : (
                      "-"
                    )}
                  </>
                )}
                {Number(daysDifference) > 0 && (
                  <div className="t-text-body-sm t-text-red">
                    In {daysDifference} days
                  </div>
                )}
              </div>
            );
          },
          header: "Deadline",
          size: 15,
          minSize: 120,
        }),
      ]
    : [];

  const estimatedTimeForDelivery = isCpa
    ? [
        columnHelper.accessor("estimated_time_of_delivery", {
          cell: ({ row }) => (
            <EstimdatedTimeColumn
              taskData={row.original}
              isCustomTrigger={true}
            />
          ),
          header: () => (
            <ToolTip text="Estimated time of delivery">
              <span className="t-pl-1">ETD</span>
            </ToolTip>
          ),
          size: 5,
          minSize: 153,
        }),
      ]
    : [];

  const columns = [
    columnHelper.accessor("title", {
      cell: (info) => {
        const rowData = info.row?.original;
        const isCompleted = rowData?.state_details?.type === SUBMITTED;

        const notStarted =
          (rowData?.state_details?.type === FORM_FILING ||
            rowData?.state === null) &&
          rowData?.state_details?.type !== SUBMITTED;

        const inProgress =
          rowData?.state_details?.type !== FORM_FILING &&
          rowData?.state !== null &&
          rowData?.state_details?.type !== SUBMITTED;

        return (
          <div className="t-flex t-flex-col t-gap-0.5">
            <Link
              to={`/tax/filings/${rowData.uuid}`}
              className="t-truncate t-max-w-64 t-text-body-sm hover:!t-underline"
              target={rowData.uuid}
              onClick={stopPropagation}
            >
              {rowData.title}
            </Link>
            <div className="t-flex t-gap-1 t-items-center">
              <div className="t-text-text-30 t-text-body-sm">
                {rowData.season}
              </div>
              <span className="t-text-neutral-10">|</span>
              <span className="t-flex t-gap-1 t-items-center">
                <span
                  className={classNames(
                    "t-w-2 t-h-2 t-rounded-full t-text-body-sm",
                    {
                      "t-bg-dark_green": isCompleted,
                      "t-bg-red": notStarted,
                      "t-bg-yellow": inProgress,
                    }
                  )}
                ></span>
                <span className="t-text-body-sm t-text-text-30">
                  {(rowData?.state as string) || NOT_STARTED}
                </span>
              </span>
              {rowData.is_archived && (
                <>
                  <span className="t-text-neutral-10">|</span>
                  <TagComp icon={false} size="small" tagType="gray">
                    A
                  </TagComp>
                </>
              )}
            </div>
          </div>
        );
      },
      header: "Filing",
      size: 18,
      minSize: 310,
    }),

    columnHelper.display({
      id: "task_state_dropdown",
      header: "STATE",
      size: 15,
      minSize: 160,
      cell: ({ row }) => <TaskStateDropdown task={row.original} />,
    }),

    columnHelper.accessor("group_name", {
      cell: (info) => {
        const rowData = info.row?.original;
        const groupDetailsRoute = isForeignCA
          ? `/practice/crm/${rowData?.group_uuid}`
          : `/crm/${rowData?.group_uuid}`;

        const handleGroupClick = (e: React.MouseEvent) => {
          e.stopPropagation();
          if (rowData?.has_group_perm) {
            openLink(groupDetailsRoute, rowData?.group_uuid);
          }
        };

        return (
          <div className="t-flex t-flex-col">
            <div className="t-flex t-gap-2 t-items-center">
              <Button
                size="small"
                customType={rowData?.has_group_perm ? "link" : "link_neutral"}
                onClick={handleGroupClick}
              >
                <div className="t-truncate t-max-w-36 t-text-body-sm hover:t-underline">
                  {rowData.group_name}
                </div>
              </Button>
              {Boolean(rowData?.subscription_name) &&
                rowData?.subscription_name !== "NOT_STARTED" && (
                  <Badge
                    size="small"
                    color={
                      CRM_SUBSCRIPTION_TYPE[
                        rowData?.subscription_name as
                          | "STANDARD"
                          | "PRO"
                          | "PAYG"
                          | "BYOA"
                      ]
                    }
                  >
                    {
                      CRM_SUBSCRIPTION_BADGE_MAP[
                        rowData?.subscription_name as
                          | "STANDARD"
                          | "PRO"
                          | "PAYG"
                          | "BYOA"
                      ]
                    }
                  </Badge>
                )}
            </div>
            <div className="t-flex t-items-center t-gap-1.5 t-text-body-sm t-text-text-30">
              <span className="t-truncate t-max-w-36">
                {rowData.entity.name}
              </span>
              {Boolean(rowData.client_progress?.amendment_number) && (
                <>
                  <span>·</span>
                  <AmendmentTag
                    amendmentNumber={rowData.client_progress?.amendment_number}
                  />
                </>
              )}
            </div>
          </div>
        );
      },
      header: "Group",
      size: 7,
      minSize: 200,
    }),
    columnHelper.accessor("tags", {
      cell: (info) => {
        const rowData = info.row?.original;
        return (
          <FilingTags
            taskId={rowData.uuid}
            currentTags={rowData?.tags}
            tags={tags}
          />
        );
      },
      header: "Tags",
      size: 10,
      minSize: 173,
    }),
    columnHelper.accessor("assigned_agent.name", {
      cell: ({ row }) => (
        <AvatarCell
          profileUrl={row.original.assigned_agent?.profile_url}
          name={row.original.assigned_agent?.name}
        />
      ),
      header: "Agent",
      size: 6,
      minSize: 99,
    }),

    ...serviceTeamColumn,
    ...preparerColumn,

    columnHelper.display({
      cell: ({ row }) => (
        <TaskPickupDate
          hasAssignedTeam={Boolean(row.original.assigned_team)}
          taskId={row.original.uuid}
          pickupDate={row.original.pickup_date}
        />
      ),
      header: "Pickup date",
      size: 9,
      minSize: 153,
    }),
    columnHelper.accessor("assigned_at", {
      cell: ({ row }) => {
        const isDatePresent = !!row.original.assigned_at;

        if (isDatePresent) {
          return <div>{formatDate(row.original.assigned_at)}</div>;
        }
        return <div>-</div>;
      },
      header: "Preparer Assigned On",
      size: 7,
      minSize: 122,
    }),
    columnHelper.display({
      cell: ({ row }) => <ReviewerColumn taskData={row.original} />,
      header: "Reviewer",
      size: 7,
      minSize: 125,
    }),
    columnHelper.display({
      cell: ({ row }) => {
        const isDatePresent = !!row.original.reviewer_assigned_on;

        if (isDatePresent) {
          return <div>{formatDate(row.original.reviewer_assigned_on)}</div>;
        }
        return <div>-</div>;
      },
      header: "Reviewer Assigned On",
      size: 7,
      minSize: 122,
    }),
    ...estimatedTimeForDelivery,
    ...banksConnections,
    ...transactions,
    ...formationType,
    columnHelper.display({
      id: "notes",
      cell: (info) => (
        <TaskNotes
          taskId={info.row.original.uuid}
          groupId={info.row.original.group_uuid}
          entityId={info.row.original.entity.uuid}
          currentNoteLabel="Notes for this filing"
          allNotesCount={info.row.original.notes_count || 0}
        />
      ),
      header: "",
      size: 10,
      minSize: 10,
    }),
    columnHelper.accessor("channel", {
      header: "",
      //TODO:  Currently task list api and task api gives two diffrent response but uses same type, change this
      // @ts-ignore
      cell: memo((info: CellContext<Task, string>) => (
        <ChatSlider
          {...info}
          channelUnreadMap={channelUnreadMap}
          openTaskChat={openTaskChat}
        />
      )),
      size: 4,
      minSize: 40,
    }),
  ];

  return columns;
};

const SliderWapper = ({
  taskSliderTab,
  onTaskSliderClose,
}: {
  taskSliderTab: TaskSliderTabs;
  onTaskSliderClose: () => void;
}) => {
  const params = useParams<{ filingsId?: string }>();
  const taskSliderId = params.filingsId;

  return (
    <TaskSlider
      taskId={taskSliderId}
      isOpen={Boolean(taskSliderId)}
      onClose={onTaskSliderClose}
      defaultTab={taskSliderTab}
    />
  );
};

export const ForeignCATask = ({ hideTabBar }: { hideTabBar?: boolean }) => {
  const { isCustomer, isAdmin, isServiceSuperAdmin, isCpa, isForeignCA } =
    useRoleBasedView();
  const { data: serviceTeam = [] } = useGetAssignAgentsQuery(
    {},
    {
      skip: !isAdmin,
    }
  );
  const assignees = [
    ...serviceTeam,
    { name: NO_ASSIGNEE, profile_id: NO_ASSGINEE_KEY },
  ];
  usePageTitle("Filings");
  const { update } = useUpdateQuery();
  const { data } = useGetTaskTemplatesQuery();
  const { templates = [] } = data || {};
  const query = useQuery();
  const [showTagModal, setShowTagModal] = useState(false);
  const pageNumber = Number(query.get("page") || 1);
  const searchTerm = query.get("search_term") || null;
  const selectedTag = query.get("task_tag_filter_uuids") || null;
  const selectedCompanyTag = query.get("company_tag_filter_uuids") || null;
  const selectedFilingInfo = query.get("filing_infos") || null;
  const selectedStateRegistrations = query.get("state_registrations") || null;
  const selectedSubscription = query.get("subscription_filter") || null;
  const stateFilter = query.get("task_state_filter_uuids") || null;
  const selectedFormationType =
    query.get("formation_type_filter_uuids") || null;
  const selectedTemplate = query.get("task_template_filter_uuids") || null;
  const assigneeFilter = query.get("assignee_uuids") || null;
  const selectedTeams = query.get("service_team_uuids") || null;
  const selectedMembers = query.get("team_member_uuids") || null;
  const selectedETD = query.get("etd_filter") || null;
  const status = query.get("status");
  const showUnassignedTeam = query.get("show_unassigned_team");
  const showUnassignedPreparer = query.get("show_unassigned_preparer");
  const [selectedSortOption, setSelectedSortOption] = useState<{
    id: number;
    title: string;
    value: string;
    sortKey: string | null;
  }>(
    sortOptions.find(
      (option) => option.sortKey === query.get("task_sort_by")
    ) || defaultSortOption
  );
  const [isTabSwitched, setIsTabSwitched] = useState(false);
  const { data: tagsData = [] } = useGetTaskTagQuery();
  const { data: taskStatesData = [] } = useGetAllTaskStatesQuery();
  const { authtoken } = useContext(authContext);
  const { practicecrmId } = useParams<{ practicecrmId?: string }>();
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});
  const history = useHistory();

  const [exportCSV, { isLoading: exportingCsv }] = useLazyExportCSVQuery();
  const { path } = useRouteMatch();
  const serviceTeamId = practicecrmId || authtoken.service_team_id;
  const [taskSliderTab, setTaskSliderTab] = useState<TaskSliderTabs>(
    TASK_SLIDER_TABS.DETAILS
  );
  const { search } = useLocation();

  const taskStates = [
    ...taskStatesData,
    { name: NOT_STARTED, uuid: NOT_STARTED_KEY },
  ];

  const tags = useMemo(
    () => [
      ...tagsData,
      {
        title: NO_TAG,
        uuid: NO_TAG_KEY,
        bg_color_hex: "",
        color_hex: "",
        tag_category: 0,
      },
    ],
    [tagsData]
  );

  const { values, updateFilter } = useFilters<FilterType>({
    initialValue: {
      START_DATE: "",
      END_DATE: "",
      SELECT_PERIOD: "",
      DEADLINE_START: "",
      DEADLINE_END: "",
      DEADLINE_SELECT_PERIOD: "",
      FORMATION_TYPE: [],
      STATE_REGISTRATIONS: [],
      FILING_INFO: [],
    },
  });

  const { END_DATE, START_DATE, FORMATION_TYPE } = values;

  const filingInfoFilters = useMemo(
    () => selectedFilingInfo?.split(",") || [],
    [selectedFilingInfo]
  );

  const bookkeepingStatusFilter =
    filingInfoFilters
      .reduce<string[]>((ac, cv) => {
        if (cv == BOOKS_COMPLETED) {
          ac.push("COMPLETED");
        }
        if (cv == BOOKS_IN_PROGRESS) {
          ac.push("IN_PROGRESS");
        }
        if (cv == BOOKS_NOT_STARTED) {
          ac.push("NOT_STARTED");
        }
        return ac;
      }, [])
      .join(",") || null;

  const profitableFilter =
    filingInfoFilters
      .reduce<string[]>((ac, cv) => {
        if (cv == PROFITABLE) {
          ac.push("yes");
        }
        if (cv == NON_PROFITABLE) {
          ac.push("no");
        }
        return ac;
      }, [])
      .join(",") || null;

  const taskFilters = {
    page_num: pageNumber,
    search_term: searchTerm,
    task_tag_filter_uuids: selectedTag,
    company_tag_filter_uuids: selectedCompanyTag,
    task_state_filter_uuids: stateFilter,
    task_template_filter_uuids: selectedTemplate,
    assignee_uuids: assigneeFilter,
    task_sort_by: selectedSortOption.sortKey,
    subscriptionFilter: selectedSubscription,
    generate_report: false,
    task_list_type: status,
    service_team_ids: (serviceTeamId ? serviceTeamId : selectedTeams) || null,
    etd_type: selectedETD,
    preparer_ids: selectedMembers,
    completed_start_date: START_DATE
      ? dayjs(START_DATE).format(YYYY_MM_DD)
      : null,
    completed_end_date: END_DATE ? dayjs(END_DATE).format(YYYY_MM_DD) : null,
    deadline_start: values.DEADLINE_START
      ? dayjs(values.DEADLINE_START).format(YYYY_MM_DD)
      : null,
    deadline_end: values.DEADLINE_END
      ? dayjs(values.DEADLINE_END).format(YYYY_MM_DD)
      : null,
    show_unassigned_team: showUnassignedTeam,
    show_unassigned_preparer: showUnassignedPreparer,
    formation_types: selectedFormationType,
    state_registrations: selectedStateRegistrations,
    profitability_status: profitableFilter,
    missing_business_financials_form_7004_flag:
      filingInfoFilters.includes(MISSING_BUSINESS_FINANCIALS_FORM_7004_FLAG) ||
      null,
    missing_information_form_7004_flag:
      filingInfoFilters.includes(MISSING_INFORMATION_FORM_7004_FLAG) || null,
    bookkeeping_status: bookkeepingStatusFilter,
  };

  const {
    data: allServiceProviders,
    isLoading,
    isFetching,
  } = useGetAllServiceProviderTaskQuery(taskFilters, {
    refetchOnMountOrArgChange: true,
  });

  const {
    tasks = [],
    total_pages,
    total_count,
    per_page = 20,
  } = allServiceProviders || {};

  const channelUrls = tasks.map((t) => t.channel as unknown as string);
  const showConnectionColoumn = tasks.some(
    (t) => t.active_bank_connections !== null
  );
  const showTotalTxnColoumn = tasks.some(
    (t) => t.number_of_transactions !== null
  );

  const channelUnreadMap = useUnreadFromChannels({
    channelUrls,
    queryOptions: { limit: per_page },
  });

  const tableData = useMemo(() => tasks, [tasks]);

  const paginationData = {
    totalPage: total_pages || 0,
    currentPage: pageNumber,
    itemsPerPage: per_page,
    totalItemCount: total_count || 0,
  };

  useEffect(() => {
    if (!isFetching) {
      setIsTabSwitched(false);
    }
  }, [isTabSwitched, isFetching]);

  const onTaskRowClick = (taskId: string, taskSliderTab: TaskSliderTabs) => {
    history.push(`/admin/filings/${taskId}${search}`);
    setTaskSliderTab(taskSliderTab);
  };

  const onTaskSliderClose = () => {
    history.push(`/admin/filings${search}`);
  };

  const columns = useMemo(() => {
    const selectColumn = columnHelper.display({
      id: "selection",
      size: 1,
      minSize: SELECTION_COL_WIDTH,
      enableSorting: false,
      header: ({ table }) => (
        <div className="t-normal-case">
          <Checkbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
            }}
            onChange={table.getToggleAllRowsSelectedHandler()}
          />
        </div>
      ),

      cell: ({ row }) => (
        <div className="t-ml-1 t-bg-white group-hover:!t-bg-surface-lighter-grey t-z-20">
          <Checkbox
            {...{
              checked: row.getIsSelected(),
              disabled: !row.getCanSelect(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
              key: row.id,
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      ),
    });

    return [
      selectColumn,
      ...taskColumns({
        isAdmin,
        isCpa,
        tags,
        channelUnreadMap,
        isServiceSuperAdmin,
        openTaskChat: onTaskRowClick,
        isForeignCA,
        showTotalTxnColoumn,
        showConnectionColoumn,
        isCustomer,
      }),
    ];
  }, [
    JSON.stringify(channelUnreadMap),
    isAdmin,
    isCpa,
    tags,
    isServiceSuperAdmin,
    onTaskRowClick,
    isForeignCA,
    showTotalTxnColoumn,
    showConnectionColoumn,
  ]);

  const table = useReactTable({
    data: tableData,
    columns,
    getCoreRowModel: getCoreRowModel(),
    defaultColumn: {
      minSize: 1,
    },
    onRowSelectionChange: setRowSelection, //hoist up the row selection state to your own scope
    state: {
      rowSelection, //pass the row selection state back to the table instance
      columnPinning: {
        left: ["selection", "group_name"],
      },
    },
    getRowId: (row) => row.uuid,
  });

  const handleClose = () => {
    setShowTagModal(false);
  };

  const allSelectedRows = Object.entries(rowSelection)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  const onExportCSV = async () => {
    const csvData = await exportCSV({
      task_uuids: allSelectedRows.join(","),
      task_type_key: "FORM_7004",
    }).unwrap();

    const linkElement = document.createElement("a");
    linkElement.target = "_blank";
    linkElement.href = `data:${csvData.ContentType};base64,${csvData.Content}`;
    linkElement.download = `Inkle US Tax Deadlines Calendar ${formatDate()}`;
    linkElement.click();
    linkElement.remove();
  };

  const selectedRowsServiceTeam =
    tableData
      .filter(
        ({ assigned_team, uuid }) =>
          allSelectedRows.includes(uuid) && assigned_team?.uuid
      )
      .map(({ assigned_team }) => assigned_team?.uuid!) || [];

  const canUpdateDeadline = tableData
    .filter(({ uuid }) => allSelectedRows.includes(uuid))
    .every(
      ({ base_task_key }) =>
        base_task_key === STATE_FILING || base_task_key === AD_HOC
    );

  const resetSelection = () => {
    setRowSelection({});
    table.resetRowSelection();
  };

  return (
    <>
      <DashboardContainer className="t-h-full">
        <DashboardContainer.Header>
          {!hideTabBar && <TaskTabBar defaultValue="admin/filings" />}
        </DashboardContainer.Header>
        <div className="t-px-5 t-pb-4 t-flex t-flex-col t-gap-4 t-h-full t-overflow-hidden">
          <div className="t-flex t-flex-col t-gap-4 t-sticky t-top-0 t-bg-white t-z-header">
            <div className="t-flex t-items-center t-gap-x-2">
              <ForeignCATaskFilter
                searchedTerm={searchTerm}
                selectedTag={selectedTag}
                selectedCompanyTag={selectedCompanyTag}
                tags={tags}
                selectedStateFilter={stateFilter}
                taskStates={taskStates}
                selectedTemplateFilter={selectedTemplate}
                selectedAssignee={assigneeFilter}
                assignees={assignees}
                selectedSortOption={selectedSortOption}
                setSelectedSortOption={setSelectedSortOption}
                showSortFeature={true}
                update={update}
                totalCount={total_count!}
                selectedSubscription={selectedSubscription}
                paginationData={paginationData}
                isLoading={isFetching && !isLoading}
                selectedETD={selectedETD}
                selectedTeams={selectedTeams}
                selectedMembers={selectedMembers}
                values={values}
                updateFilter={updateFilter}
                serviceTeamId={serviceTeamId}
                showUnassignedTeam={showUnassignedTeam}
                showUnassignedPreparer={showUnassignedPreparer}
                taskFilters={JSON.stringify(taskFilters)}
                selectedFilingInfo={selectedFilingInfo}
                selectedStateRegistrations={selectedStateRegistrations}
                selectedFormationType={selectedFormationType}
              >
                <ToggleGroup
                  size="small"
                  onValueChange={(value) => {
                    if (value) {
                      update({
                        query: "status",
                        value: value !== ALL ? value : null,
                      });
                      setIsTabSwitched(true);
                    }
                  }}
                  value={status || ALL}
                >
                  <ToggleGroupItem value={ALL}>All</ToggleGroupItem>
                  <ToggleGroupItem value={ONGOING}>Ongoing</ToggleGroupItem>
                  <ToggleGroupItem value={COMPLETED}>Completed</ToggleGroupItem>
                  <ToggleGroupItem value={ARCHIVED}>Archived</ToggleGroupItem>
                </ToggleGroup>
              </ForeignCATaskFilter>
            </div>
          </div>

          {isLoading || isTabSwitched ? (
            <Loader />
          ) : tableData.length === 0 ? (
            <NoDataAvailable noDataText="Tax & compliance filings started for your clients will show up here" />
          ) : (
            <div className="t-overflow-auto t-flex-1 t-min-h-0">
              <Table.Container className="t-min-w-[100rem] t-pb-20">
                <Table.Content>
                  <Table.Head>
                    {table.getHeaderGroups().map((headerGroup) => (
                      <Table.Row key={headerGroup.id}>
                        {headerGroup.headers.map((header) => {
                          const isPinned = header.column.getIsPinned();
                          const isSelectionCol =
                            header.column.id === "selection";
                          const isGroupNameCol =
                            header.column.id === "group_name";
                          return (
                            <Table.HeadCell
                              key={header.id}
                              style={{
                                width: `${header.getSize()}%`,
                                minWidth: header.column.columnDef.minSize,
                                position: "sticky",
                                top: 0,
                                ...(isSelectionCol && {
                                  width: SELECTION_COL_WIDTH,
                                  maxWidth: SELECTION_COL_WIDTH,
                                  left: 0,
                                  zIndex: 30,
                                }),
                                ...(isGroupNameCol && {
                                  left: SELECTION_COL_WIDTH,
                                  zIndex: 20,
                                  width: GROUP_NAME_COL_WIDTH,
                                  maxWidth: GROUP_NAME_COL_WIDTH,
                                }),
                              }}
                              className={classNames({
                                "!t-bg-white": !!isPinned,
                                "t-drop-shadow-table-left-pin": isGroupNameCol,
                                "t-bg-surface-lighter-grey t-z-10": true,
                              })}
                            >
                              {header.isPlaceholder
                                ? null
                                : flexRender(
                                    header.column.columnDef.header,
                                    header.getContext()
                                  )}
                            </Table.HeadCell>
                          );
                        })}
                      </Table.Row>
                    ))}
                  </Table.Head>
                  <Table.Body>
                    {table.getRowModel().rows.map((row) => (
                      <Table.Row
                        onRowClick={() =>
                          onTaskRowClick(
                            row.original.uuid,
                            TASK_SLIDER_TABS.DETAILS
                          )
                        }
                        key={row.id}
                        className="t-group hover:t-bg-surface-lighter-grey"
                      >
                        {row.getVisibleCells().map((cell) => {
                          const isPinned = cell.column.getIsPinned();
                          const isSelectionCol = cell.column.id === "selection";
                          const isGroupNameCol =
                            cell.column.id === "group_name";
                          return (
                            <td
                              key={cell.id}
                              style={{
                                width: `${cell.column.getSize()}%`,
                                minWidth: cell.column.columnDef.minSize,
                                ...(isSelectionCol && {
                                  position: "sticky",
                                  width: SELECTION_COL_WIDTH,
                                  maxWidth: SELECTION_COL_WIDTH,
                                  left: 0,
                                  zIndex: 5,
                                }),
                                ...(isGroupNameCol && {
                                  position: "sticky",
                                  left: SELECTION_COL_WIDTH,
                                  zIndex: 5,
                                  width: GROUP_NAME_COL_WIDTH,
                                  maxWidth: GROUP_NAME_COL_WIDTH,
                                }),
                              }}
                              className={classNames("t-p-2 t-text-nowrap", {
                                "t-bg-white group-hover:!t-bg-surface-lighter-grey":
                                  !!isPinned,
                                "t-drop-shadow-table-left-pin": isGroupNameCol,
                              })}
                            >
                              {flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext()
                              )}
                            </td>
                          );
                        })}
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table.Content>
              </Table.Container>
            </div>
          )}
          <AllFilingBulkActionFloat
            table={table}
            resetSelection={resetSelection}
            selectedRowsServiceTeam={selectedRowsServiceTeam}
            onExportCSV={onExportCSV}
            exportingCsv={exportingCsv}
            canUpdateDeadline={canUpdateDeadline}
          />
        </div>
      </DashboardContainer>
      <TagCreation show={showTagModal} handleClose={handleClose} />
      <Switch>
        <Route path={`${path}/:filingsId`}>
          <SliderWapper
            taskSliderTab={taskSliderTab}
            onTaskSliderClose={onTaskSliderClose}
          />
        </Route>
      </Switch>
    </>
  );
};
